/* eslint-disable max-statements */
/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-04-28 14:40:54
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-13 15:54:33
 */

import MeshManage from '../../meshManage';
import SkirtingBoard from '../../specialHandler/skirtingBoard';
import {
  AXES_ENUM, BASICRENDER_TYPE, BASICTYPE_ENUM, LengthLocation, LengthType,
} from '../../utils/enum';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG } from '../../utils/kitchenConfig';
import { checkHasHightFrameByPosition } from '../../utils/renderUtils';

import renderTopPanelUtil from './renderUTopPanel';

function renderSkirtingBoardUtil(renderUThis) {
  const skirtingBoardTexture = renderUThis?.templateJson?.bottom?.coverPlate?.componentBasic?.modelUrl;
  const lastFrame = renderUThis.templateJson.bottom.length1?.frames[
    renderUThis.templateJson.bottom.length1.frames.length - 1];

  // const lastFrameDoor = lastFrame.doors[0];
  const mesh = renderUThis.scene.getMeshByName(lastFrame.componentBasic.id);
  if (!mesh) {
    return;
  }
  const bounds = mesh.getHierarchyBoundingVectors();
  const bottomType = renderUThis.templateJson.bottom.type;
  const doorDepth = 0;

  // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
  // add by zhanyu.shen 20211221 end

  // add by zhanyu.shen 20211229 begin
  let highFrameData = null;
  let highFrameFrontSideLength = 0; // 顶柜组里高柜的正面边长
  let sealPlateSizeX = 0; // 底柜和高柜间的补板长
  let highFrameSkirtingBoard = [];
  // 检查顶柜里是否有高柜 处理Length1边
  if (checkHasHightFrameByPosition(renderUThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
    highFrameData = renderUThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length1);
    highFrameFrontSideLength = highFrameData?.size?.x;
    if (renderUThis.isSealPlateBeforeTopHightFrame(LengthType.Length1, true)) {
      // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如L1边底柜99顶柜167)，L1正面踢脚板长度延伸，右面位置移动到高柜右边
      sealPlateSizeX = renderUThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
    } else if (renderUThis.checkTopHightFrameIsSeparated(LengthType.Length1)) {
      // 底柜和顶柜高柜分离
      // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
      highFrameSkirtingBoard = renderUThis.renderTopHighFrameSkirtingBoardLength1(highFrameData, skirtingBoardTexture);
      highFrameFrontSideLength = 0; // 原先的踢脚板长度不需要延伸
      sealPlateSizeX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    } else {
      /** 此时底柜和高柜之间能连接在一起，如果L1边只有一个转角柜，有补板的话会放在高柜前面，sealPlateSizeX需要作为踢脚板延伸长度
       * （比如L1边底柜104顶柜159）
       *  L1边有多个柜子且有补板，补板的话会放在第一个柜子后面，sealPlateSizeX不需要作为踢脚板延伸长度
       * （比如L1边底柜114顶柜173）
      */
      sealPlateSizeX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    }
  } else {
    // 顶柜没有高柜，获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
    sealPlateSizeX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
  }
  // add by zhanyu.shen 20211229 end
  if (sealPlateSizeX === 0 && renderUThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
    // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
    sealPlateSizeX = renderUThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
  }
  // L1正面的踢脚板
  const position1 = {
    // version 2.0, modify by zhanyu.shen 20211229 把补板和顶柜高柜宽度计入踢脚板X坐标
    // x: (bounds.min.x - FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH) / 2,
    x: (bounds.min.x - FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH) / 2
      - sealPlateSizeX / 2 - highFrameFrontSideLength / 2,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: FRAMEDEPTH.BOTTOM - SKIRTINGBOARDCONFIG.DEPTH / 2 - doorDepth,
  };
  const size1 = {
    // version 2.0, modify by zhanyu.shen 20211221 把补板和顶柜高柜宽度计入踢脚板width
    // width: Math.abs(bounds.min.x) - FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH,
    width: Math.abs(bounds.min.x) - FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH
      + sealPlateSizeX + highFrameFrontSideLength,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: SKIRTINGBOARDCONFIG.DEPTH,
  };
  const skirtingBoard1 = new SkirtingBoard(renderUThis.scene, position1, size1);
  skirtingBoard1.shadowInfo = {
    width: size1.width,
    lengthType: LengthType.Length1,
    type: renderUThis?.templateJson?.bottom?.type,
  };
  skirtingBoard1.createSkirtingBoard(skirtingBoardTexture);
  renderUThis.skirtingBoard.push(skirtingBoard1);

  // L1右面的踢脚板
  const position2 = {
    // version 2.0, modify by zhanyu.shen 20211229 把补板和顶柜高柜宽度计入踢脚板X坐标，L1右面只需移动位置尺寸不变
    // x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2,
    x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - sealPlateSizeX - highFrameFrontSideLength,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: FRAMEDEPTH.BOTTOM / 2,
  };
  const size2 = {
    width: SKIRTINGBOARDCONFIG.DEPTH,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: FRAMEDEPTH.BOTTOM - doorDepth,
  };
  const skirtingBoard2 = new SkirtingBoard(renderUThis.scene, position2, size2);

  skirtingBoard2.createSkirtingBoard(skirtingBoardTexture);
  renderUThis.skirtingBoard.push(skirtingBoard2);


  let lastFrame2 = renderUThis.templateJson.bottom.length2?.frames[
    renderUThis.templateJson.bottom.length2.frames.length - 1];
  if (!lastFrame2) {
    lastFrame2 = renderUThis.templateJson.bottom.length1?.frames[0];
  }
  const mesh2 = renderUThis.scene.getMeshByName(lastFrame2.componentBasic.id);
  const bounds2 = mesh2.getHierarchyBoundingVectors();
  // L2正面的踢脚板
  const position3 = {
    x: -SKIRTINGBOARDCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: bounds2.max.z * 0.5 + FRAMEDEPTH.BOTTOM - doorDepth - FRAMEDEPTH.BOTTOM,
  };
  const size3 = {
    width: SKIRTINGBOARDCONFIG.DEPTH,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: bounds2.max.z - FRAMEDEPTH.BOTTOM * 2 + doorDepth * 2,
  };
  let sealPlateSizeZ = 0;
  if (bottomType === BASICRENDER_TYPE.U_S) {
    // U型L3边深40，L2边没有柜体，补板会在L1转角柜后面，比如L2=175
    sealPlateSizeZ = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
    position3.z = (bounds2.max.z + FRAMEDEPTH.BOTTOM + sealPlateSizeZ + SKIRTINGBOARDCONFIG.DEPTH) / 2;
    size3.depth = bounds2.max.z - FRAMEDEPTH.BOTTOM + sealPlateSizeZ + SKIRTINGBOARDCONFIG.DEPTH;
  }
  const skirtingBoard3 = new SkirtingBoard(renderUThis.scene, position3, size3);
  skirtingBoard3.shadowInfo = {
    width: size3.depth,
    lengthType: LengthType.Length2,
    type: renderUThis?.templateJson?.bottom?.type,
  };
  skirtingBoard3.createSkirtingBoard(skirtingBoardTexture);
  renderUThis.skirtingBoard.push(skirtingBoard3);

  // 隐藏L1时显示的踢脚线
  // 有可能存在l2frames为空
  let lastHideFrame2 = renderUThis.templateJson.bottom.length2?.frames[0];
  if (!lastHideFrame2) {
    lastHideFrame2 = renderUThis.templateJson.bottom.length1?.frames[0];
  }
  const hideMesh2 = renderUThis.scene.getMeshByName(lastHideFrame2.componentBasic.id);
  const hideBounds2 = hideMesh2.getHierarchyBoundingVectors();
  const hideMesh2sealPlateSizePX = renderUThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.x);
  const position6 = {
    x: -SKIRTINGBOARDCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: (bounds2.max.z + hideBounds2.min.z - FRAMEDEPTH.BOTTOM) / 2,
  };
  const size6 = {
    width: SKIRTINGBOARDCONFIG.DEPTH,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: bounds2.max.z - hideBounds2.min.z - hideMesh2sealPlateSizePX - FRAMEDEPTH.BOTTOM,
  };
  if (bottomType === BASICRENDER_TYPE.U_S) {
    // U型L3深40时，调整隐藏L1时的L2边踢脚线
    const meshManage2 = new MeshManage(mesh2);
    const meshsize2 = meshManage2.getModelSize();
    position6.z = mesh2.position.z;
    size6.depth = meshsize2.z;
  }
  const skirtingBoard6 = new SkirtingBoard(renderUThis.scene, position6, size6);
  skirtingBoard6.createSkirtingBoard(skirtingBoardTexture);
  skirtingBoard6.setHideLength(1);
  renderUThis.skirtingBoard.push(skirtingBoard6);
  skirtingBoard6?.mesh?.setEnabled(false);

  // 隐藏L3时显示的踢脚线
  // const lastHideFrame3 = renderUThis.templateJson.bottom.length2?.frames[
  //   renderUThis.templateJson.bottom.length2?.frames.length - 2];
  const hasLength1 = renderUThis.templateJson.bottom.length1?.frames.length; // 可能length1上面只有一个转角柜
  const hasLength3 = renderUThis.templateJson.bottom.length3?.frames.length; // 可能length2上面只有一个转角柜
  // 判断在L1只有一个转角柜 L2只有一个转角柜 L3没有柜体这个情况下只能获取L2的转角柜
  const subtractNum = (hasLength3 && renderUThis.templateJson.bottom.length2.frames.length > 1) && hasLength1 !== 1;
  // 有可能存在l2frames为空
  let lastHideFrame3 = renderUThis.templateJson.bottom.length2?.frames[
    renderUThis.templateJson.bottom.length2.frames.length - (subtractNum ? 2 : 1)
  ];
  if (!lastHideFrame3) {
    lastHideFrame3 = renderUThis.templateJson.bottom.length1?.frames[0];
  }

  const hideMesh3 = renderUThis.scene.getMeshByName(lastHideFrame3.componentBasic.id);
  const hideBounds3 = hideMesh3.getHierarchyBoundingVectors();
  let hideMesh3sealPlateSizePZ = renderUThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
  let positionZ;
  let sizeDepth;
  if (subtractNum) {
    positionZ = (hideBounds3.max.z + FRAMEDEPTH.BOTTOM) / 2;
    sizeDepth = hideBounds3.max.z - FRAMEDEPTH.BOTTOM;
  } else {
    if (renderUThis.templateJson.bottom.length2.frames.length > 1) {
      // L2边框体至少有两个，旋转隐藏L3时，L2只隐藏最后一个转角柜，踢脚板为L2剩余柜体到L1
      hideMesh3sealPlateSizePZ = 0;
    }
    positionZ = (hideBounds3.min.z + FRAMEDEPTH.BOTTOM - hideMesh3sealPlateSizePZ) / 2;
    sizeDepth = hideBounds3.min.z - FRAMEDEPTH.BOTTOM - hideMesh3sealPlateSizePZ;
  }
  if (bottomType === BASICRENDER_TYPE.U_S && renderUThis.templateJson.bottom.length2?.frames.length === 0) {
    positionZ = (bounds2.max.z + FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH) / 2;
    sizeDepth = bounds2.max.z - FRAMEDEPTH.BOTTOM + SKIRTINGBOARDCONFIG.DEPTH;
  }

  const position7 = {
    x: -SKIRTINGBOARDCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: positionZ,
  };

  const size7 = {
    width: SKIRTINGBOARDCONFIG.DEPTH,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: sizeDepth,
  };
  const skirtingBoard7 = new SkirtingBoard(renderUThis.scene, position7, size7);
  skirtingBoard7.createSkirtingBoard(skirtingBoardTexture);
  skirtingBoard7.setHideLength(3);
  renderUThis.skirtingBoard.push(skirtingBoard7);
  // renderUThis.skirtingBoard.push({ ...skirtingBoard7, hide: 3 });
  skirtingBoard7?.mesh?.setEnabled(false);

  let lastFrame3 = renderUThis.templateJson.bottom.length3?.frames[
    renderUThis.templateJson.bottom.length3.frames.length - 1];
  let mesh3;
  let bounds3;
  let meshSize3;
  let mesh3Position;
  if (lastFrame3) {
    mesh3 = renderUThis.scene.getMeshByName(lastFrame3.componentBasic.id);
    bounds3 = mesh3.getHierarchyBoundingVectors();
    meshSize3 = new MeshManage(mesh3).getModelSize();
    meshSize3.z = FRAMEDEPTH.BOTTOM - doorDepth;
    mesh3Position = mesh3.position;
  } else {
    // 如果L3没有柜子只有一个L2的转角柜
    lastFrame3 = renderUThis.templateJson.bottom.length2?.frames[
      renderUThis.templateJson.bottom.length2.frames.length - 1];
    mesh3 = renderUThis.scene.getMeshByName(lastFrame3.componentBasic.id);
    bounds3 = mesh3.getHierarchyBoundingVectors();
    meshSize3 = new MeshManage(mesh3).getModelSize();
    mesh3Position = mesh3.position;
    bounds3 = mesh3.getHierarchyBoundingVectors();
    mesh3Position = {
      x: mesh3Position.x - meshSize3.x / 2 + meshSize3.x / 2 - FRAMEDEPTH.BOTTOM / 2,
      y: mesh3Position.y,
      z: mesh3Position.z + meshSize3.z / 2 - FRAMEDEPTH.BOTTOM / 2,
    };
    meshSize3 = { x: meshSize3.x - FRAMEDEPTH.BOTTOM, y: meshSize3.y, z: FRAMEDEPTH.BOTTOM };

    // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜平行X轴补板尺寸，如果补板在柜子中间，该值为0，如果length3边有柜子该值为0
    // add by zhanyu.shen 20211221 end
  }

  // add by zhanyu.shen 20211229 begin
  let highFrameData3 = null;
  let highFrameFrontSideLength3 = 0; // 顶柜组里高柜的正面边长
  let sealPlateSizePX = 0; // 底柜和高柜间的补板长
  let highFrameSkirtingBoard3 = [];
  // 检查顶柜里是否有高柜 处理Length1边
  if (checkHasHightFrameByPosition(renderUThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length3)) {
    highFrameData3 = renderUThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length3);
    highFrameFrontSideLength3 = highFrameData3?.size?.x;
    if (renderUThis.isSealPlateBeforeTopHightFrame(LengthType.Length3, true)) {
      // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如L1边底柜99顶柜167)，L1正面踢脚板长度延伸，右面位置移动到高柜右边
      sealPlateSizePX = renderUThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
    } else if (renderUThis.checkTopHightFrameIsSeparated(LengthType.Length3)) {
      // 底柜和顶柜高柜分离
      // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
      highFrameSkirtingBoard3 = renderUThis.renderTopHighFrameSkirtingBoardLength1(
        highFrameData3, skirtingBoardTexture, LengthType.Length3,
      );
      highFrameFrontSideLength3 = 0; // 原先的踢脚板长度不需要延伸
      sealPlateSizePX = renderUThis.getSealPlateSizeOnlyOneFrame(
        LengthLocation.Bottom, LengthType.Length3, AXES_ENUM.x,
      );
    } else {
      /** 此时底柜和高柜之间能连接在一起，如果L1边只有一个转角柜，有补板的话会放在高柜前面，sealPlateSizeX需要作为踢脚板延伸长度
       * （比如L1边底柜104顶柜159）
       *  L1边有多个柜子且有补板，补板的话会放在第一个柜子后面，sealPlateSizeX不需要作为踢脚板延伸长度
       * （比如L1边底柜114顶柜173）
      */
      sealPlateSizePX = renderUThis.getSealPlateSizeOnlyOneFrame(
        LengthLocation.Bottom, LengthType.Length3, AXES_ENUM.x,
      );
    }
  } else {
    // 顶柜没有高柜，获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
    sealPlateSizePX = renderUThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length3, AXES_ENUM.x);
  }
  // add by zhanyu.shen 20211229 end
  if (sealPlateSizePX === 0 && renderUThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length3)) {
    // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
    sealPlateSizePX = renderUThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
  }

  // L3正面的踢脚板
  const position4 = {
    // version 2.0, modify by zhanyu.shen 20211229 把补板和顶柜高柜宽度计入踢脚板平行X坐标
    // x: mesh3Position.x - meshSize3.x / 2 - bounds3.min.x / 2 - FRAMEDEPTH.BOTTOM / 2,
    x: mesh3Position.x - meshSize3.x / 2 - bounds3.min.x / 2 - FRAMEDEPTH.BOTTOM / 2
      - sealPlateSizePX / 2 - highFrameFrontSideLength3 / 2,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: mesh3Position.z - meshSize3.z / 2 + SKIRTINGBOARDCONFIG.DEPTH / 2,
  };
  const size4 = {
    // version 2.0, modify by zhanyu.shen 20211229 把补板和顶柜高柜宽度计入踢脚板平行X尺寸
    // width: -bounds3.min.x - FRAMEDEPTH.BOTTOM,
    width: -bounds3.min.x - FRAMEDEPTH.BOTTOM + sealPlateSizePX + highFrameFrontSideLength3,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: SKIRTINGBOARDCONFIG.DEPTH,
  };
  if (bottomType === BASICRENDER_TYPE.U_S) {
    position4.z = mesh3Position.z - FRAMEDEPTH.USBOTTOM / 2 + SKIRTINGBOARDCONFIG.DEPTH / 2;
  }
  const skirtingBoard4 = new SkirtingBoard(renderUThis.scene, position4, size4);
  skirtingBoard4.shadowInfo = {
    width: size4.width,
    lengthType: LengthType.Length3,
    type: renderUThis?.templateJson?.bottom?.type,
  };
  skirtingBoard4.createSkirtingBoard(skirtingBoardTexture);
  renderUThis.skirtingBoard.push(skirtingBoard4);
  // L3左面的踢脚板
  const position5 = {
    // version 2.0, modify by zhanyu.shen 20211229 把补板和顶柜高柜宽度计入踢脚板平行X坐标，L3左面只需移动位置尺寸不变
    // x: bounds3.min.x + SKIRTINGBOARDCONFIG.DEPTH / 2,
    x: bounds3.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - sealPlateSizePX - highFrameFrontSideLength3,
    y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
    z: mesh3Position.z,
  };
  const size5 = {
    width: SKIRTINGBOARDCONFIG.DEPTH,
    height: SKIRTINGBOARDCONFIG.HEIGHT,
    depth: bottomType === BASICRENDER_TYPE.U_S ? FRAMEDEPTH.USBOTTOM : meshSize3.z,
  };
  const skirtingBoard5 = new SkirtingBoard(renderUThis.scene, position5, size5);

  skirtingBoard5.createSkirtingBoard(skirtingBoardTexture);
  renderUThis.skirtingBoard.push(skirtingBoard5);

  renderUThis.skirtingBoard.forEach((e) => {
    renderUThis.addMesh(e.mesh);
  });
  // renderUThis.skirtingBoardObjs = [skirtingBoard1, skirtingBoard2, skirtingBoard3, skirtingBoard4, skirtingBoard5];
  // eslint-disable-next-line no-param-reassign
  renderUThis.skirtingBoardObjs = [
    skirtingBoard1,
    skirtingBoard2,
    skirtingBoard3,
    skirtingBoard4,
    skirtingBoard5,
    skirtingBoard6,
    skirtingBoard7,
    ...highFrameSkirtingBoard,
    ...highFrameSkirtingBoard3,
  ];
}

export {
  renderSkirtingBoardUtil,
  renderTopPanelUtil,
};
